module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-2-fill-267c28fc.svg";